/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Start_ButtonInputs */



/**
* | output |
* | --- |
* | "Start" |
*
* @param {Style_Guide_Start_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_start_button = /** @type {((inputs?: Style_Guide_Start_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Start_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Start")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начинать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comenzar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始")
	if (locale === "ja") return /** @type {LocalizedString} */ ("始める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शुरू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Começar")
	return /** @type {LocalizedString} */ ("Start")
});